<p class="qundis-inter-400">Bitte den Benutzer definieren</p>
<form
  class="admin-form user-form"
  [formGroup]="userForm"
  *ngIf="storageService.userroles()"
>
  <mat-form-field>
    <mat-label>Benutzername</mat-label>
    <input matInput type="text" formControlName="username"/>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Vorname</mat-label>
    <input matInput type="text" formControlName="firstName"/>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Nachname</mat-label>
    <input matInput type="text" formControlName="lastName"/>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Status</mat-label>
    <mat-select formControlName="isActive">
      <mat-option
        *ngFor="
          let option of [
            { name: 'aktiv', value: true },
            { name: 'inaktiv', value: false }
          ]
        "
        [value]="option.value"
      >
        {{ option.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Benutzerrolle</mat-label>
    <mat-select formControlName="userrole">
      <mat-option
        *ngFor="let userrole of storageService.userroles()"
        [value]="userrole.name"
      >
        {{ userrole.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field
    *ngIf="
      userForm.get('userrole')?.value === Userrole.Teamleiter ||
      userForm.get('userrole')?.value === Userrole.Schichtleiter
    "
  >
    <mat-label>Zugeordnete Produktionslinie</mat-label>
    <mat-select formControlName="productionLine">
      <mat-option
        *ngFor="let productionLine of productionLineService.productionLines()"
        [value]="productionLine.id + '%' + productionLine.name"
      >{{ productionLine.name }}
      </mat-option
      >
    </mat-select>
    <!--        <mat-error>Dieser Benutzerrolle muss eine Produktionslinie zugeordnet werden</mat-error>-->
  </mat-form-field>
  <mat-form-field>
    <mat-label>Email</mat-label>
    <input matInput type="text" formControlName="email"/>
    <!--<mat-error
            *ngIf="userForm.controls['email'].dirty
            && (userForm.controls['email'].hasError('required')
            || userForm.controls['email'].hasError('email'))">
        <span>Benutzer mit dieser Benutzerrolle benötigen eine gütlige E-Mail Adresse</span>
    </mat-error>-->
  </mat-form-field>
  <mat-form-field>
    <mat-label>Telefon</mat-label>
    <input matInput type="text" formControlName="phone"/>
  </mat-form-field>
  <mat-form-field *ngIf="action() === 'create'">
    <mat-label>Passwort</mat-label>
    <input matInput type="text" formControlName="password"/>
  </mat-form-field>
  <div
    *ngIf="userForm.get('userrole')?.value === Userrole.Techniker"
    class="notifications-section mt-2"
  >
    <h3 class="qundis-inter-500">E-Mail Benachrichtigungen</h3>
    <p class="qundis-inter-400">Wählen Sie die Produktionslinien aus, für die E-Mail Benachrichtigungen
      empfangen werden sollen</p>

    <div class="notification-items d-flex flex-row flex-wrap" formArrayName="notifications">
      <div class="notification-item mx-2" *ngFor="let line of productionLineService.productionLines(); let i = index">
        <mat-slide-toggle [formControlName]="i">
          {{ line.name }}
        </mat-slide-toggle>
      </div>
    </div>
  </div>
</form>
<button
  *ngIf="userBeingEdited()"
  class="btn btn-qundis-warn mt-3 mb-4"
  (click)="resetPassword()"
>
  Passwort zurücksetzen
</button>


<app-save-cancel-buttons
  [backRoute]="'/admin/users'"
  [isFormValid]="userForm.valid"
  (saveEvent)="save()"
></app-save-cancel-buttons>
